module.exports = __webpack_public_path__ + "img/wordpress.1ce96a86.png";